<script setup lang="ts">
import type { HTMLAttributes } from 'vue';
import { cn } from '@/lib/utils';

/**
 * The 3ojo wordmark, as it is set on the marketing site: a white numeral
 * against gold letters, heavy weight, open tracking.
 *
 * The split colour is the whole point of the mark — "3" reads as the third
 * eye, "ojo" as the eye itself — so it lives in one component rather than
 * being retyped as spans at each of the three places it appears.
 *
 * Size is the caller's business: pass a `text-*` class. Everything else here
 * is fixed, because a wordmark that changes weight or tracking between the
 * nav and the sign-in page is not a wordmark.
 */
defineProps<{ class?: HTMLAttributes['class'] }>();
</script>

<template>
  <!-- No whitespace between the spans: a newline here renders as a word gap
       and splits the mark in two. -->
  <span :class="cn('font-display font-bold tracking-wide', $props.class)"
    ><span class="text-parchment">3</span><span class="text-gold">ojo</span></span
  >
</template>
